'use strict'

const getInputComponents = require('./getInputComponents')
const { DROPDOWN_OPTIONS } = require('../componentRoles')

module.exports = contexts =>
  getInputComponents(contexts.filter(({ role }) => role !== DROPDOWN_OPTIONS))



// WEBPACK FOOTER //
// ./helpers/getDisableableInputComponents.js